
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zpravy/[newsSlug]",
      function () {
        return require("private-next-pages/zpravy/[newsSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zpravy/[newsSlug]"])
      });
    }
  